import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=0e79c549&"
import script from "@/components/PieChart/PieChart.ts?vue&type=script&lang=ts&"
export * from "@/components/PieChart/PieChart.ts?vue&type=script&lang=ts&"
import style0 from "@/components/PieChart/pie-chart.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports